const { addOrUpdateGraph } = require("./indexedDb");

const updateGraph = async ({ topic, newGraph }) => {
    addOrUpdateGraph(newGraph, topic);
}

export default updateGraph